import 'core-js/stable';
import 'regenerator-runtime/runtime';

import '@/libs/global-jquery.js';
import '@/libs/jquery-ui-1.13.1.custom/jquery-ui.min.js';

import '@/js/plugins/angular-functions.js';

import 'mousetrap/mousetrap.min.js';

import '@/libs/global-moment.js';

import '@/libs/global-underscore.js';
import '@/libs/global-backbone.js'; // required by tourist
import 'tourist/tourist.min.js';

import '@/libs/jquery-ui-1.13.1.custom/jquery-ui.css';
import '@fortawesome/fontawesome-pro/css/all.css';
import 'summernote/dist/summernote.css';

import '@/js/commonfunctions.js';
import '@/js/momentconfig.js';

/* TEST / DEBUG SERVICES */
// import '@/js/tests/PerformanceSrv.js';

/* GLOBAL SERVICES */
import '@/js/services/ApiSrv.js';
import '@/components/Notifications/NotificationsSrv.js';

// Launch Vue App
import './vueApp.js';

import '@/css/vue.css';
import '@/css/app.scss';
import '@/css/animations.css';

require('bootstrap/dist/js/bootstrap.min.js'); // required by summernote
require('script-loader!summernote');
require('summernote/dist/lang/summernote-fr-FR.min.js');
